import { render, staticRenderFns } from "./AgendaSection.vue?vue&type=template&id=247e4cf0&scoped=true&"
import script from "./AgendaSection.vue?vue&type=script&lang=js&"
export * from "./AgendaSection.vue?vue&type=script&lang=js&"
import style0 from "./AgendaSection.vue?vue&type=style&index=0&id=247e4cf0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e4cf0",
  null
  
)

export default component.exports